import {
  applyOfficialPlayoffOutcomes as applyShared,
  OverlayPickerSurface,
} from '../shared/official-playoff-overlay';

export type { OverlayPickerSurface };

/**
 * NBA canonical round-name → priority. Server emits these strings from
 * NbaPlayoffSource.DetermineRound (C#). Six rounds map to the 6 postseason
 * weeks:
 *   PlayInRound1       = MaxWeek+1
 *   PlayInRound2       = MaxWeek+2
 *   FirstRound         = MaxWeek+3
 *   ConferenceSemifinal = MaxWeek+4
 *   ConferenceFinal    = MaxWeek+5
 *   NbaFinals          = TotalWeeks (= MaxWeek+6)
 */
export const NBA_ROUND_ORDER: Record<string, number> = {
  PlayInRound1:        1,
  PlayInRound2:        2,
  FirstRound:          3,
  ConferenceSemifinal: 4,
  ConferenceFinal:     5,
  NbaFinals:           6,
};

/**
 * Applies official NBA playoff outcomes to the picker bracket.
 * Delegates to the shared algorithm in src/shared/official-playoff-overlay.ts
 * with NBA_ROUND_ORDER. The picker import in schedule-picker.ts is a 2-arg
 * call (picker + playoffs) — this wrapper supplies the round-order map.
 */
export function applyOfficialPlayoffOutcomes(
  picker: OverlayPickerSurface,
  playoffs: ILeaguePlayoffs
): void {
  applyShared(picker, playoffs, NBA_ROUND_ORDER);
}
